var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHazH({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56.62 56.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:red;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "15.35 12.98 23.51 12.98 23.52 24.57 33.15 24.57 33.15 12.98 41.28 12.97 28.26 0 15.35 12.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "41.33 43.68 33.12 43.68 33.1 32.09 23.48 32.09 23.48 43.68 15.3 43.68 28.31 56.94 41.33 43.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "15.35 13 0 28.35 15.3 43.68 15.35 13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "41.28 43.68 56.63 28.32 41.32 13 41.28 43.68"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHazH);
export default __webpack_public_path__ + "static/media/haz_h.f797a24be0e785ca74e07132a8d95e27.svg";
export { ForwardRef as ReactComponent };